import { Roles } from "../../../mp-utils/generic-utils"
import { ManagePages } from "../../types"

export const pathToManagePageType = {
  "district-admins": {
    managePage: ManagePages.DistrictAdmins,
    accountRole: Roles.District_Admin
  },
  "school-admins": {
    managePage: ManagePages.SchoolAdmins,
    accountRole: Roles.School_Admin
  },
  teachers: {
    managePage: ManagePages.Teachers,
    accountRole: Roles.Teacher
  },
  students: {
    managePage: ManagePages.Students,
    accountRole: Roles.Student
  }
}
